<script>
import Multiselect from 'vue-multiselect';
import Svgicon from 'vue-svgicon';

export default {
  functional: true,
  render(createElement, context) {
    const customProps = {
      placeholder: 'Choisissez une option',
      showLabels: false,
    };

    const customSlots = {
      noResult: () => createElement('span', 'Aucun élément trouvé.'),
      // caret: () => createElement(
      //   'div', { class: 'multiselect__select' },
      //   [
      //     createElement(
      //       Svgicon, { props: { name: 'dropdown', width: '24', height: '24' } },
      //     ),
      //   ]),
    };

    const contextSlots = context.slots();

    const scopeSlots = Object.keys(contextSlots).reduce(
      (initial, value) =>
        Object.assign(initial, { [value]: () => contextSlots[value] }),
      {},
    );

    return createElement(
      Multiselect,
      {
        class: context.data.staticClass,
        style: context.data.staticStyle,
        attrs: context.data.attrs,
        props: { ...customProps, ...context.props },
        scopedSlots: { ...customSlots, ...scopeSlots },
        on: context.listeners,
        key: context.data.key,
        ref: context.data.ref,
      },
      context.children,
    );
  },
};
</script>
